export default __webpack_public_path__ + "static/media/newSquare40.72449e0f.png";